import { render, staticRenderFns } from "./PollsList.vue?vue&type=template&id=92242156&scoped=true"
import script from "./PollsList.vue?vue&type=script&lang=js"
export * from "./PollsList.vue?vue&type=script&lang=js"
import style0 from "./PollsList.vue?vue&type=style&index=0&id=92242156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92242156",
  null
  
)

export default component.exports